import React from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { useMRQContext } from "../MRQContext";
import MrqDetails from "../../../BOMTab/MRQTab/components/MrqDetails";
import MrqMaterialsTable from "../../../BOMTab/MRQTab/components/MrqMaterialsTable";
import useClientPlants from "../../../../../../../../hooks/useClientPlants";

export default function MRQBOM() {
  const { plantId } = useParams();
  const { plants } = useClientPlants();
  const plant = plants.find((p) => String(p.id) === String(plantId)) || {
    id: plantId,
  };

  const { mrqData, isEditMode, onChangeDetails } = useMRQContext();

  return (
    <Box sx={{ maxWidth: "1200px" }}>
      <MrqDetails
        plant={plant}
        mrq={mrqData}
        isEditMode={isEditMode}
        onChangeDetails={onChangeDetails}
      />
      <MrqMaterialsTable
        mrqData={mrqData}
        isEditMode={isEditMode}
        onChangeCell={onChangeDetails}
      />
    </Box>
  );
}
